<template>
  <div>
    <vx-card class="mb-4">
      <h4 class="mb-1">{{ $t('settlement.title') }}</h4>
      <small class="text-muted d-block">{{ $t('settlement.hint') }}</small>
      <div class="mt-2 flex items-center gap-2">
        <b-form-select v-model="filterStatus" :options="statusFilters" size="sm" style="width: 220px" @change="load"/>
        <span v-if="openTotalCents > 0" class="text-danger">
          {{ $t('settlement.open_total') }}: <strong>{{ money(openTotalCents) }}</strong>
        </span>
      </div>
    </vx-card>

    <vx-card>
      <div v-if="isLoading" class="text-center py-4 text-muted">{{ $t('common.loading') }}</div>
      <div v-else-if="!rows.length" class="text-center py-4">
        <feather-icon icon="CheckCircleIcon" class="h-8 w-8 text-success mb-1"/>
        <p class="text-muted mb-0">{{ $t('settlement.empty') }}</p>
      </div>

      <table v-else class="w-full admin-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t('settlement.legal_entity') }}</th>
            <th>{{ $t('commission.order') }}</th>
            <th class="text-right">{{ $t('settlement.amount') }}</th>
            <th>{{ $t('status') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in rows" :key="s.id">
            <td>{{ s.id }}</td>
            <td>{{ _.get(s, 'legal_entity.name') || `#${s.legal_entity_id}` }}</td>
            <td>#{{ s.order_id }}</td>
            <td class="text-right"><strong>{{ money(s.amount_cents) }}</strong></td>
            <td>
              <vs-chip transparent :color="s.status === 'PG' ? 'success' : (s.status === 'CA' ? 'dark' : 'warning')">
                {{ $t(`settlement.status_.${s.status}`) }}
              </vs-chip>
              <small v-if="s.external_reference" class="text-muted d-block">{{ s.external_reference }}</small>
            </td>
            <td class="text-right">
              <b-button
                v-permission="'wallet_settlements.settle'"
                v-if="s.status === 'OP'"
                size="sm" variant="primary" @click="settle(s)">
                {{ $t('settlement.settle') }}
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </vx-card>
  </div>
</template>

<script>
import { BButton, BFormSelect } from 'bootstrap-vue'
import WalletAdminService from '@/services/api/WalletAdminService'

export default {
  components: { BButton, BFormSelect },
  data: () => ({ service: null, rows: [], isLoading: false, filterStatus: 'OP' }),
  computed: {
    statusFilters() {
      return [
        { text: this.$t('settlement.status_.OP'), value: 'OP' },
        { text: this.$t('settlement.status_.PG'), value: 'PG' },
        { text: this.$t('settlement.filter_all'), value: '' }
      ]
    },
    /** Só faz sentido somar o que está em aberto — é a dívida corrente. */
    openTotalCents() {
      return this.rows
        .filter(r => r.status === 'OP')
        .reduce((total, r) => total + Number(r.amount_cents || 0), 0)
    }
  },
  methods: {
    money(cents) {
      return (Number(cents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    load() {
      this.isLoading = true
      const params = this.filterStatus ? { status: this.filterStatus } : {}
      this.service.settlements(params).then(
        r => { this.rows = r.data || [] },
        () => { this.rows = [] }
      ).finally(() => { this.isLoading = false })
    },
    settle(settlement) {
      const reference = window.prompt(this.$t('settlement.reference_prompt'))
      if (reference === null) return

      this.$vs.loading()
      this.service.settle(settlement.id, reference || '').then(
        () => { this.notifySuccess(this.$vs, this.$t('messages.success')); this.load() },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.$vs.loading.close() })
    }
  },
  beforeMount() { this.service = WalletAdminService.build(this.$vs) },
  mounted() { this.load() }
}
</script>

<style scoped>
.admin-table th { font-size: 0.75rem; opacity: 0.7; text-align: left; padding-bottom: 0.35rem; }
.admin-table td { padding: 0.55rem 0.4rem; border-top: 1px solid rgba(0,0,0,0.06); vertical-align: top; }
.text-right { text-align: right; }
</style>
